<div class="grow container">
  <lum-ui-autocomplete
    [placeholder]="'Search fulfillment channel'"
    [options]="fulfillmentChannels"
    [debounceTime]="500"
    [loading$]="loading$"
    [displayProperty]="'label'"
    [value]="displayValue"
    (inputChangeEvent)="onChangeEvent($event)"
    (optionSelectedEvent)="onSelectEvent($event)"
    class="input-box"
    (scrollPaginate)="onScrollPaginate()"
  ></lum-ui-autocomplete>
</div>
